import { createThunk, model, Model } from 'mst-collection';
import { types } from 'mobx-state-tree';

import { useRoot } from '../useRoot';
import { LatestTrackListModel } from './LatestTrackListModel';
import { PopularTrackListModel } from './PopularTrackListModel';
import {
  Api,
  ITrackResponse,
  IUserPublicResponse,
  schemas,
} from '@api';
import { TrackFeedbacksModel } from './TrackFeedbacksModel';

export class Tracks extends Model({
  latest: types.optional(LatestTrackListModel, {}),
  popular: types.optional(PopularTrackListModel, {}),
  feedback: types.optional(TrackFeedbacksModel, {}),
}) {
  fetchUsersAndMerge = createThunk(
    (tracksResponse: ITrackResponse[]) => {
      return async function fetchUsersAndMerge(flow) {
        const userIds = tracksResponse.map((t) => t.userUploadId);

        const usersResponse = await Api.Profile.getSharedData(
          userIds,
        );

        const normalizedUsers = flow.normalize(
          usersResponse.data,
          schemas.UserListSchema,
        );

        return tracksResponse.map((track) => ({
          ...track,
          user: normalizedUsers.entities.users[
            track.userUploadId
          ] as IUserPublicResponse,
        }));
      };
    },
  );
}

export const TracksModel = model(Tracks);

export function useTracksModel() {
  const root = useRoot();

  return root.track;
}
